exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":1,\"localIdentName\":\"[name]_[local]_[hash:base64:5]\"}!../../node_modules/postcss-loader/lib/index.js??postcss!./Button.css"), undefined);

// module
exports.push([module.id, ".LinkButton_linkDefault_22xc6 {\n}\n\n.LinkButton_linkCommon_160G0 {\n  text-decoration: none;\n}\n\n.LinkButton_button_3aeLs {\n  width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"linkDefault": "LinkButton_linkDefault_22xc6 " + require("-!../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":1,\"localIdentName\":\"[name]_[local]_[hash:base64:5]\"}!../../node_modules/postcss-loader/lib/index.js??postcss!./Button.css").locals["buttonDefault"] + "",
	"linkCommon": "LinkButton_linkCommon_160G0",
	"button": "LinkButton_button_3aeLs " + require("-!../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":1,\"localIdentName\":\"[name]_[local]_[hash:base64:5]\"}!../../node_modules/postcss-loader/lib/index.js??postcss!./Button.css").locals["buttonCommon"] + ""
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]_[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/LinkButton.css
// module id = 1022
// module chunks = 0